<template>
  <div class="right-sidebar-list-row w-full flex mt-2">
    <pt-form-input
      v-model="title"
      type="text"
      placeholder="Set title"
      class="w-1/7 mr-2 w-full title-input"
      @input="holidayUpdate"
    />
    <pt-form-group
      class="text-base w-1/7 mr-2 whitespace-normal"
    >
      <pt-datepicker
        v-model="start_date"
        :disabled-dates="disabledDated"
        label=""
        placeholder="Select Day"
        @selected="holidayUpdate"
        @input="holidayUpdate"
      />
    </pt-form-group>
    <pt-form-group
      class="text-base w-1/7 mr-2 whitespace-normal"
    >
      <pt-datepicker
        v-model="end_date"
        :disabled-dates="disabledDated"
        placeholder="Select Day"
        label=""
        @selected="holidayUpdate"
        @input="holidayUpdate"
      />
    </pt-form-group>
    <div class="accept-toggle w-1/7">
      <pt-form-group>
        <pt-form-switch
          ref="acceptSwitch"
          v-model="isFullDayClosed"
          on-label="Yes"
          off-label="No"
          @input="holidayUpdate"
        />
      </pt-form-group>
    </div>
    <pt-form-group
      class="text-base w-1/7 mr-2 whitespace-normal"
    >
      <pt-timepicker
        id="start_time"
        :disabled="isFullDayClosed"
        v-model="start_time"
        :hide-clear-button="true"
        class="mt-0"
        placeholder="Select Time"
        @input="holidayUpdate"
      />
    </pt-form-group>
    <pt-form-group
      class="text-base w-1/7 mr-2 whitespace-normal"
    >
      <pt-timepicker
        id="end_time"
        :disabled="isFullDayClosed"
        v-model="end_time"
        :hide-clear-button="true"
        placeholder="Select Time"
        @input="holidayUpdate"
      />
    </pt-form-group>
    <div class="w-1/7 flex justify-center">
      <pt-button
        :disabled="isDeleteDisabled"
        rounded="circular"
        class="mt-1"
        variant="danger-outline"
        @action="deleteRow"
      >
        <i class="fa fa-times" aria-hidden="true" />
      </pt-button>
    </div>
  </div>
</template>

<script>
import { PtFormGroup, PtFormInput, PtFormSwitch } from '@pathao/ui-components/esm/FormComponents';
import { PtDatepicker } from '@pathao/ui-components/esm/Datepicker';
import PtTimepicker from '@components/common/Timepicker';
import setTime from '@utils/set-time';
import getTime from '@utils/get-time';
import formatDate from '@src/utils/format-date';

export default {
  components: {
    PtFormGroup,
    PtFormInput,
    PtFormSwitch,
    PtDatepicker,
    PtTimepicker,
  },
  props: {
    holidayDetails: {
      type: Object,
      required: true,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    holidayLength: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      id: null,
      title: null,
      start_date: null,
      end_date: null,
      isFullDayClosed: true,
      start_time: null,
      end_time: null,
    };
  },
  computed: {
    isDeleteDisabled() {
      return this.holidayLength < 2;
    },
    disabledDated() {
      let toDate = new Date();
      toDate.setDate(toDate.getDate() + 1);
      return {
        to: toDate,
      };
    },
  },
  watch: {
    holidayDetails: {
      handler(newVal, oldVal) {
        if (newVal.id !== null) {
          this.id = newVal.id;
          this.title = newVal.name;
          this.start_date = newVal.start_date ? new Date(newVal.start_date) : null;
          this.end_date = newVal.end_date ? new Date(newVal.end_date) : null;
          this.isFullDayClosed = newVal.is_full_day_closed;
          this.start_time = newVal.opening_time ? setTime(new Date(), newVal.opening_time) : null;
          this.end_time = newVal.closing_time ? setTime(new Date(), newVal.closing_time) : null;
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    getDate(date) {
      return date ? formatDate(date, 'YYYY-MM-DD') : null;
    },
    getUpdatedHolidays() {
      const holiday = {
        id: this.id,
        name: this.title,
        start_date: this.getDate(this.start_date),
        end_date: this.getDate(this.end_date),
        is_full_day_closed: this.isFullDayClosed,
        opening_time: this.isFullDayClosed ? null : this.start_time ? getTime(this.start_time) : null,
        closing_time: this.isFullDayClosed ? null : this.end_time ? getTime(this.end_time) : null,
      };
      return holiday;
    },
    holidayUpdate() {
      this.$emit('updateSingleHoliday', this.getUpdatedHolidays());
    },
    deleteRow() {
      this.$emit('deleteRow', this.holidayDetails.id);
    },
  },
};
</script>
